// The door-side reader of the two IDENTITY verdicts the app injects through
// `configureAgentsData`, in the shape ruling 65 set for the authentication
// verdict beside it
// (`docs/monorepo-ui-floor-rulings/65-identity-crosses-by-injection.md`).
//
// Headless by construction: no design system, no router, no store, no `@/`,
// and — the one that matters here — no `jotai`. The overlay branch below is an
// app ATOM read app-side; what crosses this door is the boolean it resolved to.
//
// TWO MEMBERS FOR ONE QUESTION, deliberately. "Has the signed-in identity
// hydrated" has two answers depending on which window is asking: the main app
// proves it with `useUser()`, and the overlay — which has no
// `CurrentUserProvider`, so that query never resolves — proves it with the
// token-sync atom. A single merged member would force the base gate to accept
// the overlay's answer too, and the base gate does not.
//
// Neither is derivable from `getAuthTokenSync`. A token string is present
// during the boot window that INC-215 was, which is the whole reason the
// hydration verdict exists.

import { injected } from './injected-auth';

/** Has the signed-in identity finished hydrating (`!!useUser().data` app-side). */
export const useIsIdentityHydrated = (): boolean => injected('useIsIdentityHydrated')();

/** Was the auth token freshly synced from the main window (overlay branch). */
export const useIsAuthTokenSynced = (): boolean => injected('useIsAuthTokenSynced')();
